import React from 'react';
import { Pill } from './Pill';
interface SectionHeadingProps {
  eyebrow?: string;
  eyebrowTone?: 'sage' | 'gold' | 'lilac' | 'ivory';
  title: React.ReactNode;
  lead?: React.ReactNode;
  align?: 'center' | 'left';
  tone?: 'dark' | 'light';
  className?: string;
}
export function SectionHeading({
  eyebrow,
  eyebrowTone = 'sage',
  title,
  lead,
  align = 'center',
  tone = 'dark',
  className = ''
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl';
  const titleColor = tone === 'dark' ? 'text-ink' : 'text-ivory';
  const leadColor = tone === 'dark' ? 'text-stone' : 'text-ivory/70';
  return <div className={`${alignment} ${className}`} data-id="element-172" data-mp="1spslpgiejl0">
      {eyebrow ? <Pill tone={eyebrowTone} data-id="element-173" data-mp="6sc4nvklpts8">{eyebrow}</Pill> : null}
      <h2 className={`font-display text-[2rem] leading-[1.12] sm:text-4xl lg:text-[2.75rem] ${titleColor} ${eyebrow ? 'mt-5' : ''}`} data-id="element-174" data-mp="ujhmuhe0ky5p">
        {title}
      </h2>
      {lead ? <p className={`mt-4 font-sans text-base leading-relaxed ${leadColor} ${align === 'center' ? 'mx-auto max-w-readable' : 'max-w-readable'}`} data-id="element-175" data-mp="zc0yh8t55j7v">
          {lead}
        </p> : null}
    </div>;
}